import React from 'react';
import PropTypes from 'prop-types';
import { convertKeysToCamelCase } from 'helpers/baseHelper';
import style from 'assets/scss/components/common/sections/NewsletterSection.module.scss';
import { Container } from 'react-grid-system';
import useStayInformedCard from 'hooks/useStayInformedCard';
import { useTranslation } from 'react-i18next';
import leftImage from 'assets/images/newsletter-element-1.svg';
import rightImage from 'assets/images/newsletter-element-2.svg';
import TurnstileWidget from 'components/common/TurnstileWidget';

const NewsletterSection = ({ title, description }) => {
  const { t } = useTranslation();
  const {
    newsletterSection,
    emailLabel,
    newsletterSectionLeftImage,
    newsletterSectionRightImage,
    inputRow,
    turnstile,
  } = convertKeysToCamelCase(style);
  const { register, handleSubmit, errors, turnstileProps } = useStayInformedCard();

  return (
    <section className={newsletterSection} id="newsletter">
      <Container className="container-fluid pos-relative">
        <img src={leftImage} alt="left" className={newsletterSectionLeftImage} />
        <img src={rightImage} alt="left" className={newsletterSectionRightImage} />
        <h2 className="headline2">{title}</h2>
        <p className="highlight">{description}</p>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="newsletter-email" className={emailLabel}>
              {t('home.newsletter.label')}
            </label>
            {/* The widget lives in the row so it can sit between the input and
                the button once they stack on mobile, see `input-row`. */}
            <div className={`input-group ${inputRow}`}>
              <input
                id="newsletter-email"
                className="main"
                {...register('email')}
                placeholder={t('home.newsletter.placeholder')}
                type="text"
              />
              <TurnstileWidget {...turnstileProps} className={turnstile} />
              <button className="primary" type="submit">
                {t('general.buttons.signIn')}
              </button>
            </div>

            {errors?.email && <span className="errors">{t(`validation.${errors?.email?.message}`)}</span>}
          </div>
        </form>
      </Container>
    </section>
  );
};

NewsletterSection.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export default NewsletterSection;
